import { useEffect, useRef, useState } from "react";
import Image from "../Image/Image";
import { useNavigate } from "react-router-dom";
import SignOutButton from "../SignOutButton/SignOutButton";
import { useAuth } from "../../contexts/auth";
import { Notifications } from "../Notifications/Notifications";
import { useSSEContext } from "../../contexts/sse";
import { ThemeButton } from "../ThemeButton/ThemeButton";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { useTranslation } from "react-i18next";

export function UserBar({ isCollapsed, ...props }) {
	const navigate = useNavigate();
	const { user } = useAuth();
	const { isConnected } = useSSEContext();
	const [showDropdown, setShowDropdown] = useState(false);
	const refSettingsDropdown = useRef(null);
	const { t } = useTranslation();

	const handleUserConfigClick = () => {
		setShowDropdown(!showDropdown);
	};

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				refSettingsDropdown.current &&
				!refSettingsDropdown.current.contains(event.target)
			) {
				setShowDropdown(false);
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [refSettingsDropdown]);

	function getCurrentRole() {
		if (user.userData.selectedRoleId) {
			return user.userData.roles?.find(role => role.id === user.userData.selectedRoleId)?.name;
		}
		if (user.userData.isSuperAdmin) {
			return "Super Admin";
		}
		if (!user.userData.selectedRoleId && user.userData.hasRootUnitAccess) {
			return 'Administrador';
		}
	}

	return (
		<div className="cloud-user-wrapper">
			<div className="header-bar">
				<div className={`header-bar-avatar-container ${isCollapsed ? 'justify-center' : ''}`}>
					<div className="avatar-wrapper">
						<Image
							imgId={user.userData?.urlAvatar}
							name={user.userData.name}
							alt="profile"
							isProfile
							className="header-bar-avatar"
							onClick={handleUserConfigClick}
						/>
						{/* {user.userData.selectedOrganizationId && ( */}
						<span className={`${isConnected ? 'online' : 'offline'}-badge`}></span>
						{/* )} */}
					</div>
					{!isCollapsed &&
						<>
							<span
								className="header-bar-avatar-info"
								onClick={handleUserConfigClick}
							>
								<span className="text-[0.85rem]!">{user.userData.name}</span>
								<span>{getCurrentRole()}</span>
							</span>
						</>
					}
				</div>
				{!isCollapsed &&
					<div className="flex flex-row items-center gap-2">
						<ThemeButton />
						<Notifications />
					</div>
				}
			</div>
			{showDropdown && (
				<div className="dropdown" ref={refSettingsDropdown}>
					<span
						className="dropdown-span"
						onClick={() => {
							setShowDropdown(false);
							navigate("../edit-profile", { replace: true });
						}}
					>
						{t('common.configurations')}
					</span>
					<SignOutButton />
					<LanguageSwitcher />
				</div>
			)}
		</div>
	);
}